module.exports = __webpack_public_path__ + "media/images/lb/711-c7f5aa1277a1a8e209aaf57157d37fcb.svg";